import React, { useState } from "react";
import { Button, DatePicker, Modal, Tooltip } from "antd";
import dayjs from "dayjs";
import "./DateSentRec.css";
import { useDispatch, useSelector } from "react-redux";
import {
  reqRecDate,
  srtDataSaver,
  srtLogs,
} from "../../../../Redux/actions/Srt/Srt";
import resetCalendar from "../../../../images/calendarReset.png";
import Info from "../../../../images/info.png";
import BeatLoader from "react-spinners/BeatLoader";

const DateSentRec = ({
  createdDate,
  reqNo,
  dataOfReq,
  recieveDate,
  requestRecievedDate,
  itemData,
  salesSample,
  dataOfRow,
}) => {
  const dispatch = useDispatch();
  const dateFormat = "MM/DD/YYYY";
  const isToday = dayjs().format(dateFormat);
  const [date, setDate] = useState(isToday);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const reqRecivedData = useSelector((state) => state?.Srt?.reqRecDateVar);
  const userNameMicrosoft = useSelector(
    (state) => state?.Profile?.graphCompleteData?.displayName
  );
  const logsDetailData = useSelector((state) => state?.Srt?.srtLogsData);
  const brandNameFromApi = useSelector((state) => state?.Srt?.srtBrandNames);
  const SrtLogsLoading = useSelector((state) => state?.Srt?.srtLogsLoading);

  const [isLogsModalOpen, setisLogsModalOpen] = useState(false);

  const onDateChange = (date, dateString) => {
    dispatch(
      srtDataSaver(
        itemData?.style,
        itemData?.brand,
        itemData?.factory,
        itemData?.size,
        itemData?.season,
        itemData?.color_code,
        dataOfReq?.request_no,
        "",
        "",
        dateString,
        "",
        salesSample,
        userNameMicrosoft,
        brandNameFromApi
      )
    );
    dispatch(reqRecDate({ ...reqRecivedData, request_recieved: dateString }));
    setDate(dateString);
  };

  const disabledDate = (current, receiveDate) => {
    // disable dates before the receiveDate + 3 weeks
    const currentDate = dayjs(createdDate);
    if (current < currentDate.startOf("day")) {
      return true;
    }
    // disable dates after 3 months from today
    //  const threeMonthsLater = currentDate.add(3, 'months');
    //  if (current > threeMonthsLater.endOf('day')) {
    //    return true;
    //  }
    return false;
  };

  const onResetClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  const onContinue = () => {
    dispatch(
      srtDataSaver(
        itemData?.style,
        itemData?.brand,
        itemData?.factory,
        itemData?.size,
        itemData?.season,
        itemData?.color_code,
        dataOfReq?.request_no,
        "",
        "",
        null,
        dataOfReq?.QtyRcd == null ? "" : dataOfReq?.QtyRcd,
        salesSample,
        userNameMicrosoft,
        brandNameFromApi
      )
    );
    setIsModalOpen(!isModalOpen);
  };
  const handleCancel = () => {
    setIsModalOpen(!isModalOpen);
  };
  const onDatePickerHandle = (reqNo, dataOfReq) => {
    dispatch(
      reqRecDate(
        reqRecivedData?.request_no === reqNo ? reqRecivedData : dataOfReq
      )
    );
  };

  const datePickerFunction = () => {
    if (requestRecievedDate) {
      const dateObj = dayjs(requestRecievedDate);
      const formattedDate = dateObj.format("MM/DD/YYYY");
      return (
        <DatePicker
          allowClear={false}
          onClick={() => onDatePickerHandle(reqNo, dataOfReq)}
          value={dayjs(formattedDate, "MM/DD/YYYY")}
          disabledDate={disabledDate}
          // disabled={
          //   !recieveDate ||
          //   recieveDate == " " ||
          //   recieveDate == "" ||
          //   recieveDate == null ||
          //   recieveDate == "null"
          // }
          onChange={onDateChange}
          format="MM/DD/YYYY"
        />
      );
    } else {
      return (
        <DatePicker
          allowClear={false}
          onClick={() => onDatePickerHandle(reqNo, dataOfReq)}
          onChange={onDateChange}
          disabledDate={disabledDate}
          // disabled={
          //   !recieveDate ||
          //   recieveDate == " " ||
          //   recieveDate == "" ||
          //   recieveDate == null ||
          //   recieveDate == "null"
          // }
          format="MM/DD/YYYY"
        />
      );
    }
  };
  const onLogsClick = () => {
    const season = dataOfRow?.season ? dataOfRow?.season : itemData?.season;
    const factory = dataOfRow?.factory ? dataOfRow?.factory : itemData?.factory;
    const style = dataOfRow?.style ? dataOfRow?.style : itemData?.style;
    const size = dataOfRow?.size ? dataOfRow?.size : itemData?.size;
    const color = dataOfRow?.color_code
      ? dataOfRow?.color_code
      : itemData?.color_code;
    if (season && factory && style && salesSample && color && size) {
      dispatch(
        srtLogs(
          style,
          factory,
          size,
          season,
          color,
          reqNo === null ? null : reqNo === 0 ? 0 : reqNo === -1 ? -1 : reqNo,
          salesSample
        )
      );
    }
    setisLogsModalOpen(true);
  };
  const handleLogCancel = () => {
    setisLogsModalOpen(false);
  };
  return (
    <div className="srt-table-data-three">
      <div className="srt-date-pickers">
        <p className="srt-date">{recieveDate}</p>
        <p className="srt-datepicker">
          {requestRecievedDate === "None" ||
          requestRecievedDate === "" ||
          requestRecievedDate === null ||
          requestRecievedDate === "null" ? (
            <DatePicker
              allowClear={false}
              onClick={() => onDatePickerHandle(reqNo, dataOfReq)}
              onChange={onDateChange}
              disabledDate={disabledDate}
              // disabled={
              //   !recieveDate ||
              //   recieveDate == " " ||
              //   recieveDate == "" ||
              //   recieveDate == null ||
              //   recieveDate == "null"
              // }
              format="MM/DD/YYYY"
            />
          ) : (
            <div className="date-picker-clear-container">
              {datePickerFunction()}
              <Tooltip placement="top" title={"Reset"}>
                <img
                  className="reset-icon"
                  onClick={onResetClick}
                  alt="reset-icon"
                  src={resetCalendar}
                />
              </Tooltip>
            </div>
          )}
        </p>
      </div>
      <div style={{ marginLeft: "5px", cursor: "pointer" }} onClick={onLogsClick}>
        <img height={15} width={15} src={Info} alt="info" />
      </div>
      <Modal
        title="Do you want to Reset the Received Date?"
        open={isModalOpen}
        okText={"save"}
        footer={null}
        onCancel={handleCancel}
      >
        <div className="dashboard-modal-buttons">
          <Button className="modal-yes-button" onClick={onContinue}>
            Yes
          </Button>
          <Button className="modal-cancel-btn" onClick={handleCancel}>
            Cancel
          </Button>
        </div>
      </Modal>
      <Modal
        className="srt-logs-modal-container"
        footer={null}
        title={
          <div className="srt-logs-header">
            <div className="logs-sent-header-details">
              <span>
                SRT LOGS : <b>Date Recieved</b>
              </span>
              <span>
                {dataOfRow?.season ? dataOfRow?.season : itemData?.season}
              </span>
              <span>
                {dataOfRow?.style ? dataOfRow?.style : itemData?.style}
              </span>
              <span>
                {dataOfRow?.factory ? dataOfRow?.factory : itemData?.factory}
              </span>
              <span>
                Size: {dataOfRow?.size ? dataOfRow?.size : itemData?.size}
              </span>
            </div>
            <div className="srt-logs-req">
              REQ : {reqNo === null || reqNo === 0 || reqNo === -1 ? "" : reqNo}
            </div>
          </div>
        }
        open={isLogsModalOpen}
        onCancel={handleLogCancel}
        width={790}
      >
        {SrtLogsLoading ? (
          <BeatLoader
            color={"#0C3D5E"}
            loading={SrtLogsLoading}
            size={10}
            aria-label="Loading Spinner"
            data-testid="loader"
            cssOverride={{
              margin: "30px auto",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              borderColor: "#0C3D5E",
            }}
          />
        ) : (
          <>
            {logsDetailData?.[0]?.request_recieved?.logs?.length == 0 ||
            logsDetailData.length == 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p>
                  <b>No logs yet</b>
                </p>
              </div>
            ) : (
              logsDetailData?.[0]?.request_recieved?.logs?.map((log) => (
                <div className="srt-logs-container" key={log?.log_id}>
                  <p className="log-number-container">{log?.log_id}</p>
                  <div className="srt-logs">
                    <div>
                      <p>
                        {log?.timestamp}
                        <span>
                          - <b>{log?.updated_by}</b>
                        </span>
                      </p>
                    </div>
                    <div className="logs-btn-container">
                      <p
                        style={{ whiteSpace: "normal", wordBreak: "break-all" }}
                      >
                        {log?.new_value ? log?.new_value : "NA"}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            )}
          </>
        )}
      </Modal>
    </div>
  );
};

export default DateSentRec;
